import Vue from 'vue'
export default Vue.extend({
  props: ['value'],
  data() {
    const value = this.value || [0, 0]
    return {
      left: value[0],
      right: value[1],
    }
  },
  watch: {
    value(val) {
      console.log(val)
      this.left = val[0]
      this.right = val[1]
    },
  },
  created() {
    this.left = this.value[0]
    this.right = this.value[1]
  },
  methods: {
    changeLeft(val) {
      this.left = val
      this.$emit('change', [val, this.right])
    },
    changeRight(val) {
      this.right = val
      this.$emit('change', [this.left, val])
    },
  },
  render() {
    return (
      <div>
        <a-input-number value={this.left} onChange={this.changeLeft} />
        <span> - </span>
        <a-input-number value={this.right} onChange={this.changeRight} />
      </div>
    )
  },
})
